export default __webpack_public_path__ + "static/media/sdm.779b2a58.png";